import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useEverifyUpdateCompanyStatus() {
  return useMutation({
    mutationFn: async ({ companyId, status }) => {
      const { data } = await api.put("/everifycompany/updatecompanystatus", {
        companyId,
        status,
      });
      return data;
    },
  });
}
